module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('a', {
    attrs: {
      "id": "pla"
    }
  }), _c('strong', [_vm._v("PLATES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_13_ch2#pla1"
    }
  }, [_vm._v("1. John Jones")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_13_ch2#pla2"
    }
  }, [_vm._v("2. Robert S. Abbott")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_13_ch2#pla3"
    }
  }, [_vm._v("3 and 4. Ferdinand and Ida Barnett")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_13_ch2#pla5"
    }
  }, [_vm._v("5. Olivet Baptist Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_13_ch2#pla6"
    }
  }, [_vm._v("6. Robert Mott’s Pekin Theater Cafe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_13_ch2#pla7"
    }
  }, [_vm._v("7. Negro Women Strikebreakers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_13_ch2#pla8"
    }
  }, [_vm._v("8. Negro Strikebreakers at Swift & Company")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_13_ch2#pla9"
    }
  }, [_vm._v("9. Tenements on Federal Street")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_13_ch2#pla10"
    }
  }, [_vm._v("10. Middle-Class Negro Homes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_13_ch2#pla11"
    }
  }, [_vm._v("11. Newly Arrived Negro Migrants")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_13_ch2#pla12"
    }
  }, [_vm._v("12. Alderman Oscar De Priest Posting Bond")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_13_ch2#pla13"
    }
  }, [_vm._v("13, 14, and 15. Mob Killing during the 1919 Riots")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_13_ch2#pla16"
    }
  }, [_vm._v("16. Policeman Escorting a Negro Couple during the 1919 Riot")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780226160702_13_ch2#pla17"
    }
  }, [_vm._v("17. State Militia on Guard during the 1919 Riots")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f2880dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226160702_06_pla.vue
// module id = 72
// module chunks = 0